export var formTheme = {
  sizes: {
    large: {
      formContainer: {
        rowGap: 'xxl'
      },
      form: {
        rowGap: 'l',
        columnGap: 'l'
      },
      container: {
        rowGap: 'xxs'
      }
    },
    small: {
      formContainer: {
        rowGap: 'xl'
      },
      form: {
        rowGap: 'm',
        columnGap: 'm'
      },
      container: {
        rowGap: 'xxs'
      }
    }
  },
  baseStyle: {
    form: {
      width: '100%',
      position: 'relative'
    },
    helperText: {
      color: 'neutral.darker',
      textStyle: 'body4',
      _readOnly: {
        color: 'neutral.darker'
      },
      _disabled: {
        color: 'neutral.light'
      },
      _hidden: {
        visibility: 'hidden'
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      _hidden: {
        display: 'none'
      }
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      width: '100%'
    },
    loader: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)'
    }
  },
  defaultProps: {
    size: 'large'
  }
};
//# sourceMappingURL=_Form.theme.js.map